import { useEffect, useState } from 'react';
import styles from './DrawCounter.module.css';

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

interface DrawCounterProps {
  targetDate: Date;
}

const DrawCounter = ({ targetDate }: DrawCounterProps) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const target = targetDate.getTime();
      const difference = target - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const padNumber = (num: number) => num.toString().padStart(2, '0');

  return (
    <div className={styles.container}>
      <span className={` ${styles.nextDraw}`}>Next draw in</span>
      <div className={styles.countdown}>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>{padNumber(timeLeft.days)}</span>
          <span className={` ${styles.label}`}>Days</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>
            {padNumber(timeLeft.hours)}
          </span>
          <span className={` ${styles.label}`}>Hrs</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>
            {padNumber(timeLeft.minutes)}
          </span>
          <span className={` ${styles.label}`}>Mins</span>
        </div>
        <span className={`${styles.separator}`}>:</span>
        <div className={styles.timeBlock}>
          <span className={`${styles.number}`}>
            {padNumber(timeLeft.seconds)}
          </span>
          <span className={`${styles.label}`}>Secs</span>
        </div>
      </div>
    </div>
  );
};

export default DrawCounter;
